module.exports = __webpack_public_path__ + "rewards_video_image.png";